export const PENDING = 'PENDING';
export const SUCCESS = 'SUCCESS';
export const ERROR = 'ERROR';
export const SHOW_LOADING = 'SHOW_LOADING';
export const HIDE_LOADING = 'HIDE_LOADING';
export const FETCH_ROLES = 'FETCH_ROLES';
export const SHOW_UPLOAD_MODAL = 'SHOW_UPLOAD_MODAL';

// profile
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';
export const FETCHING_PROFILE = 'FETCHING_PROFILE';

export const FETCH_STATS_STUDIES = 'FETCH_STATS_STUDIES';
export const FETCHING_STUDIES = 'FETCHING_STUDIES';
export const FETCH_STUDIES = 'FETCH_STUDIES';
export const FETCHING_TASKS = 'FETCHING_TASKS';
export const FETCH_TASKS= 'FETCH_TASKS';
export const FETCH_EXPORTED_VERSIONS = 'FETCH_EXPORTED_VERSIONS';
export const FETCHING_PROJECTS = 'FETCHING_PROJECTS';
export const FETCH_PROJECTS = 'FETCH_PROJECTS';
export const FETCH_PROJECT_DETAIL = 'FETCH_PROJECT_DETAIL';
export const FETCHING_LABELS = 'FETCHING_LABELS';
export const FETCH_LABELS = 'FETCH_LABELS';
export const FETCHING_LABEL_GROUPS = 'FETCHING_LABEL_GROUPS';
export const FETCH_LABEL_GROUPS = 'FETCH_LABEL_GROUPS';
export const SET_SELECTED_LABEL_GROUPS = 'SET_SELECTED_LABEL_GROUPS';
export const FETCHING_USERS = 'FETCHING_USERS';
export const FETCH_USERS = 'FETCH_USERS';
export const CHANGE_VIEW_MODE = 'CHANGE_VIEW_MODE';